"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementBlockEditor = void 0;
var react_1 = __importDefault(require("react"));
var QwilrEditorComponent_1 = __importDefault(require("Project/QwilrEditor/QwilrEditorComponent"));
var inversify_react_1 = require("inversify-react");
var AgreementModal_1 = require("@CommonFrontend/AgreementView/AgreementModal");
var mobx_react_1 = require("mobx-react");
exports.AgreementBlockEditor = (0, mobx_react_1.observer)(function (_a) {
    var di = _a.di;
    var modal = (0, inversify_react_1.useInjection)("modalService");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var block = (0, inversify_react_1.useInjection)(AgreementModal_1.AgreementStore).block;
    var angularModel = (0, inversify_react_1.useInjection)("angularData");
    var model = angularModel.agreementBlock;
    if (!block || !angularModel || !model) {
        console.error("No agreement attached to agreement block editor");
        return null;
    }
    return (react_1.default.createElement(QwilrEditorComponent_1.default, { key: "agreement-view", di: di, model: model.contentAreas.mainContent, configuration: "agreement", usingFeature: usingFeature, block: block, modal: modal }));
});
